export const Bio = {
  name: "Akash Kobal",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "Frontend Developer",
    "Backend Developer",
    "AI / ML Enthusiast",
    "Open Source Contributor"
  ],
  description:
    "Software Engineer experienced in building scalable microservices and web applications using Java, Spring Boot, Spring AI, React, Redis, Docker, and cloud platforms (Azure, GCP), with exposure to Generative AI integration and a strong focus on performance, reliability, and system design.",
  github: "https://github.com/AkashKobal",
  resume:
    "https://drive.google.com/file/d/18irSdGQvByoewK16Y75c-OxVm4b2_-gu/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/akash-kobal/",
  // twitter: "https://twitter.com/",
  // facebook: "https://www.facebook.com/AkashKobal05",
};

export const skills = [
  {
    title: "Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://img.icons8.com/?size=100&id=13679&format=png&color=000000",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
    ],
  },

  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "XML",
        image:
          "https://img.icons8.com/?size=100&id=87809&format=png&color=000000",
      },
      {
        name: "EJS",
        image:
          "https://img.icons8.com/?size=100&id=Pxe6MGswB8pX&format=png&color=000000",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },

  {
    title: "Backend",
    skills: [
      { name: "Node Js", image: "https://nodejs.org/static/images/logo.svg" },
      {
        name: "Express Js",
        image:
          "https://img.icons8.com/?size=100&id=2ZOaTclOqD4q&format=png&color=000000",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Java",
        image:
          "https://img.icons8.com/?size=100&id=13679&format=png&color=000000",
      },
      {
        name: "Spring Boot",
        image:
          "data:image/png;base64,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",
      },
    ],
  },

  {
    title: "Database",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "SQLite",
        image:
          "https://www.vectorlogo.zone/logos/sqlite/sqlite-icon.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },

  {
    title: "APIs",
    skills: [
      {
        name: "REST APIs",
        image:
          "https://img.icons8.com/?size=100&id=50196&format=png&color=000000",
      },
      {
        name: "Webhooks",
        image:
          "https://img.icons8.com/?size=100&id=53372&format=png&color=000000",
      },
      {
        name: "GraphQL",
        image:
          "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
    ],
  },

  {
    title: "Testing",
    skills: [
      {
        name: "JUnit",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/junit/junit-original.svg",
      },
      {
        name: "Postman",
        image:
          "https://img.icons8.com/?size=100&id=EPbEfEa7o8CB&format=png&color=000000",
      },
      {
        name: "API Testing",
        image:
          "https://img.icons8.com/?size=100&id=50196&format=png&color=000000",
      },
    ],
  },

  {
    title: "DevOps & CI/CD",
    skills: [
      {
        name: "GitHub Actions",
        image:
          "https://avatars.githubusercontent.com/u/44036562?s=200&v=4",
      },
      {
        name: "Azure Pipelines",
        image:
          "https://img.icons8.com/?size=100&id=81727&format=png&color=000000",
      },
      {
        name: "CI/CD",
        image:
          "https://img.icons8.com/?size=100&id=53372&format=png&color=000000",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://img.icons8.com/?size=100&id=20906&format=png&color=000000",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Linux",
        image:
          "https://img.icons8.com/?size=100&id=17842&format=png&color=000000",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D560BAQGDqzTvPjCjFw/company-logo_100_100/B56ZrVedWHIcAQ-/0/1764518124372?e=1767225600&v=beta&t=dGPb2D_kNh4Z_b46HSzwSluv2Ruopsm-oOReakR660E",
    role: "Software Engineer",
    company: "Learnways Academy",
    date: "Jul 2025 - Nov 2025 · 5 mos",
    location: "Bengaluru, Karnataka, India · Hybrid",
    desc: "Built and maintained Spring Boot microservices using Spring Cloud. Improved application throughput by 20% through SQL/JPA query optimization and Redis caching. Dockerized services and implemented CI/CD pipelines using Azure DevOps and Google Cloud. Actively supported production deployments and collaborated within Agile development teams to deliver stable releases.",
    skills: [
      "Java",
      "Spring Boot",
      "Spring Cloud",
      "Microservices",
      "Redis",
      "Docker",
      "CI/CD",
      "Azure DevOps",
      "Google Cloud",
      "SQL",
    ],
  },

  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/D4D0BAQFr4ZukAJpEpw/company-logo_100_100/company-logo_100_100/0/1688142380599?e=1767225600&v=beta&t=vp6cehb2kTXqHU_YvbMnIpNyxTHsXoKsuXv0UlWQPGc",
    role: "Full Stack Developer Intern",
    company: "Siraom Private Limited",
    date: "May 2024 - Aug 2024 · 4 mos",
    location: "Bengaluru, Karnataka, India · Hybrid",
    desc: "Developed scalable e-commerce REST APIs using Node.js, Express, and MySQL. Reduced API response latency by 20% through query optimization and indexing. Supported frontend integration with React and collaborated with QA teams to ensure high-quality feature delivery.",
    skills: [
      "Node.js",
      "Express.js",
      "MySQL",
      "REST APIs",
      "Database Optimization",
      "React.js",
      "Backend Performance Tuning",
    ],
  },

  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/D560BAQGtskQcDRtiYg/company-logo_100_100/company-logo_100_100/0/1732615135776?e=1767225600&v=beta&t=vgl9r0ctZJ2UOxuzCDyTWLGZjoQclAWapTnmCZY1Sv8",
    role: "Google Developer Program Member",
    company: "Google for Developers",
    date: "Jul 2023 - Jul 2024 · 1 yr 1 mo",
    location: "Remote",
    desc: "Participated in the Google Developer Program, completing hands-on labs and earning badges in Google Cloud, Firebase, Google Maps Platform, and Android SDK. Gained practical experience with cloud services and modern developer tools through guided learning and real-world scenarios.",
    skills: [
      "Google Cloud Platform",
      "Firebase",
      "Google Maps Platform",
      "Android SDK",
      "Cloud Fundamentals",
    ],
  },
];


export const education = [
  {
    id: 0,
    img: "https://res.cloudinary.com/deizvfuha/image/upload/v1723393930/images_1_in6jcj.jpg",
    school: "Presidency University, Bangalore",
    date: "Oct 2021 - June 2025",
    grade: "8.38 CGPA",
    desc: "Completed a Bachelor’s degree in Computer Science and Engineering (Data Science) at Presidency University, Bengaluru, with a CGPA of 8.38. Completed core coursework including Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks.",
    degree: "Bachelor of Technology - B.Tech, Computer Science and Engineering (Data Science)",
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/deizvfuha/image/upload/v1723393889/images_dzlkzr.jpg",
    school: "Sharanbasaveshwar composit pu science college, Kalaburagi, Karnataka",
    date: "June 2020 - Mar 2021",
    grade: "84.00%",
    desc: "I completed my class 12th high school education at Sharanbasaveshwar composit pu science college, Kalaburagi, Karnataka, where I studied Science with Computer Science.",
    degree: "State Board(XII), Science Stream(PCMCs)",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/deizvfuha/image/upload/v1723393889/images_dzlkzr.jpg",
    school: "Sharanbasaveshwar residential public school, Kalaburagi, Karnataka",
    date: "June 2018 - Apr 2019",
    grade: "86.08%",
    desc: "I completed my class 10 education at Sharanbasaveshwar residential public school, Kalaburagi.",
    degree: "State Board(X)",
  },
];
export const projects = [
  {
    id: 1,
    title: "Techways (Student Management System + Microservices)",
    date: "Aug 2025 - Oct 2025",
    description:
      "Built a modern and modular Student Management System using a microservices architecture. Implemented role-based access control, attendance tracking, quiz management, and real-time data operations. Developed with Spring Boot, Spring Cloud, React.js, and MySQL, ensuring clean service separation for scalability, maintainability, and production readiness.",
    image: "https://github.com/AkashKobal/Techways/raw/main/screenshot/sc5.png",
    tags: [
      "Microservices",
      "Spring Boot",
      "Spring Cloud",
      "React.js",
      "MySQL",
      "Full-Stack Development",
    ],
    category: "web app",
    github: "https://github.com/AkashKobal/Techways",
    webapp: "https://github.com/AkashKobal/Techways",
  },

  {
    id: 2,
    title: "User Management System",
    date: "Feb 2025 - May 2025",
    description:
      "Developed a full-stack User Management System with secure authentication and authorization workflows. Implemented OTP-based verification, login, password reset, role-based access control, Excel export with filters, email notifications, and API-level security using Spring Security. Designed to be scalable, modular, and production-ready.",
    image: "https://github.com/AkashKobal/User-Management-System/raw/main/screenshot/create_user.png",
    tags: [
      "Spring Boot",
      "Spring Security",
      "React.js",
      "MySQL",
      "Authentication",
      "Authorization",
    ],
    category: "web app",
    github: "https://github.com/AkashKobal/User-Management-System",
    webapp: "https://github.com/AkashKobal/User-Management-System",
  },

  {
    id: 3,
    title: "Generative AI Detection",
    date: "Aug 2024 - Nov 2024",
    description:
      "Built a Generative AI Detection system to identify whether text is human-written or AI-generated. Developed a React.js frontend and a Python/Flask backend with API-driven communication and intelligent scoring logic. Deployed on Vercel for fast, scalable access, demonstrating practical experience in AI prompt analysis and full-stack AI product development.",
    image: "https://github.com/AkashKobal/Generative-AI-Detection/raw/main/Screenshot%20(366).png",
    tags: [
      "Generative AI",
      "Flask",
      "Python",
      "React.js",
      "AI Text Classification",
    ],
    category: "ai / ml",
    github: "https://github.com/AkashKobal/Generative-AI-Detection",
    webapp: "https://github.com/AkashKobal/Generative-AI-Detection",
  },

  {
    id: 4,
    title: "MERN E-Commerce Platform",
    date: "May 2024 - Aug 2024",
    description:
      "Developed a full-stack e-commerce web application using the MERN stack (MongoDB, Express.js, React.js, Node.js). Implemented user authentication, product management, cart functionality, checkout flow, and secure REST API integrations. Optimized backend APIs for performance and built a responsive, user-friendly frontend.",
    image:
      "https://res.cloudinary.com/drkru3jv8/image/upload/v1712406871/Portfolio_Web/gke65rcffrobryvu9nte.png",
    tags: [
      "MERN Stack",
      "React.js",
      "Node.js",
      "MongoDB",
      "REST APIs",
    ],
    category: "web app",
    github: "https://github.com/AkashKobal",
    webapp: "",
  },

  {
    id: 5,
    title: "Arecanut Disease Detection",
    date: "Feb 2024 - May 2024",
    description:
      "Developed a deep learning–based plant disease detection system using Convolutional Neural Networks (CNNs) to classify arecanut crop diseases from images. Built an end-to-end pipeline including data preprocessing, model training, evaluation, and deployment. Implemented a React-based interface and a Python/Flask API for inference.",
    image: "https://github.com/AkashKobal/arecanut-diseases-detection/raw/main/Screenshot.png",
    tags: [
      "Deep Learning",
      "Computer Vision",
      "CNN",
      "TensorFlow",
      "Flask",
    ],
    category: "machine learning",
    github: "https://github.com/AkashKobal/arecanut-diseases-detection",
    webapp: "https://github.com/AkashKobal/arecanut-diseases-detection",
  },

  {
    id: 6,
    title: "Potato Disease Classification Using CNN",
    date: "Nov 2023",
    description:
      "Built a web application for potato disease classification using TensorFlow, CNNs, FastAPI, and React.js. The system identifies diseases such as Early Blight and Late Blight from plant images, improving agricultural diagnostics through fast and accurate predictions.",
    image:
      "https://res.cloudinary.com/deizvfuha/image/upload/v1721927447/Screenshot_2024-07-25_223937_hluewc.png",
    tags: ["TensorFlow", "CNN", "FastAPI", "React.js"],
    category: "machine learning",
    github: "https://github.com/AkashKobal/potato-disease-classification",
    webapp: "",
  },

  {
    id: 7,
    title: "Travel Tracker",
    date: "Jul 2024",
    description:
      "A web application that allows users to track countries they have visited and visualize them on a map. Built using HTML, CSS, JavaScript, EJS, Node.js, and PostgreSQL with canvas-based map rendering.",
    image:
      "https://res.cloudinary.com/deizvfuha/image/upload/v1721913944/my%20images/hrcfxnua3uv41wlqxvsu.png",
    tags: [
      "JavaScript",
      "Node.js",
      "PostgreSQL",
      "EJS",
      "HTML",
      "CSS",
    ],
    category: "web app",
    github: "https://github.com/AkashKobal/travel-tracker",
    webapp: "",
  },

  {
    id: 8,
    title: "Tic-Tac-Toe",
    date: "Aug 2023",
    description:
      "Developed an interactive Tic-Tac-Toe game using React.js, demonstrating component-based architecture, state management, and dynamic UI updates.",
    image:
      "https://res.cloudinary.com/drkru3jv8/image/upload/v1712407309/Portfolio_Web/tic-tac-toe_interface_hnbkkd.png",
    tags: ["React.js", "JavaScript", "HTML", "CSS"],
    category: "web app",
    github: "https://github.com/MayurNangre/tic-tac-toe",
    webapp: "https://mayurnangre.github.io/tic-tac-toe/",
  },

  {
    id: 9,
    title: "Music Player (Android)",
    date: "Jan 2023",
    description:
      "Built an Android music player using Java and XML in Android Studio. Implemented features such as play, pause, skip, shuffle, repeat, and playlist management using the MediaPlayer API.",
    image:
      "https://res.cloudinary.com/deizvfuha/image/upload/v1721921219/my%20images/jyzbjqnffdvsrrtpmgx9.png",
    tags: ["Java", "XML", "Android Studio"],
    category: "android app",
    github:
      "https://github.com/AkashKobal/android-development/tree/MAD/15.%20MediaPlayer",
    webapp: "",
  },

  {
    id: 10,
    title: "Weather App (Android)",
    date: "Jan 2023",
    description:
      "Developed an Android weather application using Java and XML with real-time weather data fetched via a public Weather API. Implemented API integration, JSON parsing, and a clean, user-friendly UI.",
    image:
      "https://res.cloudinary.com/deizvfuha/image/upload/v1721926194/maxresdefault_fn73av.jpg",
    tags: ["Java", "XML", "Weather API", "Android Studio"],
    category: "android app",
    github:
      "https://github.com/AkashKobal/android-development/tree/MAD/25.%20Weather_App",
    webapp: "",
  },

  {
    id: 11,
    title: "Solar-Based Remote Control Smart Garden",
    date: "Aug 2022 - Jan 2023",
    description:
      "Built a solar-powered smart garden system using Raspberry Pi to enable remote irrigation and monitoring based on soil moisture data. Improved water usage efficiency and provided real-time analytics through a custom dashboard.",
    image: "https://github.com/AkashKobal/solar-based-remote-control-smart-garden/raw/main/Project%20Image.jpg",
    tags: ["IoT", "Raspberry Pi", "Data Analytics"],
    category: "iot",
    github: "https://github.com/AkashKobal/solar-based-remote-control-smart-garden",
    webapp: "",
  },
];


export const TimeLineData = [
  { year: 2021, text: "Started B.Tech in Computer Science & Engineering (Data Science) at Presidency University" },
  { year: 2022, text: "Built Solar-Based Remote Control Smart Garden (IoT project)" },
  { year: 2023, text: "Joined Google Developer Program and built Android & web projects" },
  { year: 2024, text: "Full Stack Developer Intern at Siraom Pvt Ltd; built MERN-based e-commerce platform" },
  { year: 2024, text: "Developed AI & Deep Learning projects including Arecanut Disease Detection and Generative AI Detection" },
  { year: 2025, text: "Built Techways Student Management System using Microservices (Spring Boot & Spring Cloud)" },
  { year: 2025, text: "Software Engineer at Learnways Academy working on Spring Boot microservices and CI/CD" },
];
